import Swiper from 'swiper';
import {Navigation, Pagination, Grid, EffectFade, Thumbs, Autoplay} from 'swiper/modules'
/*import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/lazy';*/
const defModules = [Navigation, Pagination];

//Swiper.use([Navigation, Pagination, Lazy]);

let mainSwiper, fullSwiper;
let motoSwipers = {};

const hpSettings = ($root) => {
    return {
        direction: 'horizontal',
        loop: false,
        watchOverflow: true,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        preloadImages: false,
        modules: [...defModules, Autoplay],
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: $root.find('.swiper-pagination')[0],
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 5
        }
    }
}

export const mainBanner = ($root) => {
    if (!mainSwiper) {
        mainSwiper = new Swiper($root.children()[0], hpSettings($root));
    }
    return mainSwiper;
}

export const fullBanner = ($root) => {
    if (!fullSwiper) {
        fullSwiper = new Swiper($root.children()[0], hpSettings($root));
    }
    return fullSwiper;
}

export const motoSwiper = ($root) => {
    if (!($root.selector in motoSwipers)) {
        const {pagination} = hpSettings($root);
        motoSwipers[$root.selector] = new Swiper($root.find('.swiper')[0], {
            modules: [...defModules, Grid],
            pagination,
            direction: 'horizontal',
            loop: false,
            watchOverflow: true,
            watchSlidesProgress: true,
            preloadImages: false,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 16,
            grid: {
                rows: 1,
                fill: 'row'
            },
            breakpoints: {
                576: {
                    spaceBetween: 16,
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    grid: {
                        rows: 2,
                        fill: 'row'
                    }
                },
                768: {
                    spaceBetween: 16,
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    grid: {
                        rows: 2,
                        fill: 'row'
                    }
                },
                1200: {
                    spaceBetween: 16,
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    grid: {
                        rows: 2,
                        fill: 'row'
                    }
                }
            }
        });
    }
    return motoSwipers[$root.selector];
}

export const whatSaySlider = ($root) => {
    return new Swiper($root.children()[0], hpSettings($root));
}

export const manufacturerSlider = ($root) => {
    const {pagination} = hpSettings($root);
    const swiper = new Swiper($root.find('.swiper')[0], {
        modules: [...defModules, Grid],
        pagination,
        direction: 'horizontal',
        loop: false,
        watchOverflow: true,
        watchSlidesProgress: true,
        preloadImages: false,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 16,
        grid: {
            rows: 3,
            fill: 'row'
        },
        breakpoints: {
            577: {
                spaceBetween: 16,
                slidesPerView: 3,
                slidesPerGroup: 3,
                grid: {
                    rows: 3,
                    fill: 'row'
                }
            },
            769: {
                spaceBetween: 16,
                slidesPerView: 4,
                slidesPerGroup: 4,
                grid: {
                    rows: 3,
                    fill: 'row'
                }
            },
            1200: {
                spaceBetween: 16,
                slidesPerView: 6,
                slidesPerGroup: 6,
                grid: {
                    rows: 3,
                    fill: 'row'
                }
            }
        }
    });
}

export const productDetailSwiper = async ($root, $rootGallery) => {
    const gallery = new Swiper($rootGallery[0], {
        modules: defModules,
        direction: window.innerWidth >= 992 ? 'vertical' : 'horizontal',
        loop: false,
        watchOverflow: true,
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        slideToClickedSlide: true,
        spaceBetween: 15,
        navigation: {
            nextEl: $('.c-other_images-next')[0],
            prevEl: $('.c-other_images-prev')[0],
        },
    });
    const swiper = new Swiper($root[0], {
        direction: 'horizontal',
        modules: [...defModules, EffectFade, Thumbs],
        loop: false,
        autoHeight: true,
        watchOverflow: true,
        watchSlidesProgress: true,
        preloadImages: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        effect: "fade",
        thumbs: {
            swiper: gallery
        },
        fadeEffect: {
            crossFade: true
        },
    })
    const media = window.matchMedia("(max-width: 991px)");
    media.addEventListener('change', function (m){
        if (m.matches) {
            gallery.changeDirection();
        } else {
            gallery.changeDirection();
        }
    })
}